import React from 'react';
import { alpha } from "@mui/material/styles";
import { Box, useTheme, Typography } from "@mui/material";
import image from "../data/image";

const AuthFormContainer = ({ title, children, avatarSrc = image.visigalogo3 }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        bgcolor: isDarkMode ? alpha('#0D1825', 0.92) : '#ffffff',
        p: { xs: 2, sm: 2.5 },
        borderRadius: 4,
        mt: 0,
        mx: "auto",
        maxWidth: 430,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        border: `1px solid ${alpha(isDarkMode ? '#ffffff' : '#0f172a', 0.08)}`,
        boxShadow: isDarkMode
          ? "0 18px 45px rgba(0, 0, 0, 0.32)"
          : "0 20px 40px rgba(15, 23, 42, 0.10)",
      }}
    >
      <Typography
        component="h5"
        variant="h6"
        mb={0.75}
        color={isDarkMode ? 'white' : 'black'}
        textAlign="center"
      >
        ST MARY'S JUNIOR SEMINARY VISIGA
      </Typography>

      {/* Circular Logo */}
      <Box display="flex" justifyContent="center" mt={3} alignItems="center">
        <Box
          sx={{
            width: 68,
            height: 68,
            borderRadius: "16px",
            overflow: "hidden",
            cursor: "pointer",
            border: `1px solid ${alpha(isDarkMode ? '#ffffff' : '#0f172a', 0.08)}`,
          }}
        >
          <img
            src={avatarSrc}
            alt="VISIGA logo"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </Box>
      </Box>

      {/* Add space below the image */}
      <Box mb={0.5} />

      {/* Title Below Image */}
      <Box mb={1.5} display="flex" justifyContent="center">
        <Typography component="h2" variant="h6" fontWeight={700} textAlign="center">
          {title}
        </Typography>
      </Box>

      {children}
    </Box>
  );
};

export default AuthFormContainer;
